import { useState, useEffect } from 'react';

const useDelayedAction = (actionFunction, delay = 300) => {
    const [debounceTimer, setDebounceTimer] = useState(null);

    const delayedAction = (...args) => {
        clearTimeout(debounceTimer);

        const newTimer = setTimeout(() => {
            actionFunction(...args);
        }, delay);

        setDebounceTimer(newTimer);
    };

    useEffect(() => {
        return () => {
            clearTimeout(debounceTimer);
        };
    }, [debounceTimer]);

    return delayedAction;
};

export default useDelayedAction;